/**
 * i18n key (namespace `invoices`) for the unit codes the offer-based invoice stores — "MON",
 * "QU", "JHR", "LS", "HUR" and the by-effort unit "Einsatz" (FAFD-27), so the table
 * reads "3 Einsätze" instead of "3 Stk". `null` for any other, free-text unit, which is shown as
 * entered. Same mapping as the PDF (`InvoiceUnitText` in the Api).
 */
export function invoiceUnitKey(unit: string | null | undefined): string | null {
  switch (unit) {
    case 'MON':
      return 'invoices:units.month';
    case 'QU':
      return 'invoices:units.quarter';
    case 'JHR':
      return 'invoices:units.year';
    case 'LS':
      return 'invoices:units.lumpSum';
    case 'HUR':
      return 'invoices:units.hour';
    case 'Einsatz':
      return 'invoices:units.effort';
    default:
      return null;
  }
}
